<div class="pod-page" *ngIf="configLoaded && form">

  <form [formGroup]="form" (ngSubmit)="submitForm()" class="pod-form">

    <app-section-general-info
      [form]="form"
      [mode]="mode"
      [sourceType]="sourceType"
      [remoteConfig]="remoteConfig"
      [sourceTypeCatalog]="sourceTypeCatalog"
      [poTypeCatalog]="poTypeCatalog"
      [catalogsLoaded]="catalogsLoaded"
      [submitted]="formSubmitted"
      [fieldConfigs]="sectionFieldConfigs[SECTION.GENERAL_INFORMATION]"
      [lockedSourceType]="lockedSourceType"
    ></app-section-general-info>

    <app-section-po-document
      [form]="form"
      [mode]="mode"
      [sourceType]="sourceType"
      [remoteConfig]="remoteConfig"
      [submitted]="formSubmitted"
    ></app-section-po-document>

    <app-section-budget-dates
      [form]="form"
      [mode]="mode"
      [sourceType]="sourceType"
      [remoteConfig]="remoteConfig"
      [catalogsLoaded]="catalogsLoaded"
      [submitted]="formSubmitted"
      [fieldConfigs]="sectionFieldConfigs[SECTION.BUDGET_AND_DATES]"
    ></app-section-budget-dates>

    <app-section-buyer-info
      *ngIf="isSectionVisibleForSource(SECTION.BUYER_INFORMATION)"
      [form]="form"
      [mode]="mode"
      [sourceType]="sourceType"
      [remoteConfig]="remoteConfig"
      [submitted]="formSubmitted"
      [fieldConfigs]="sectionFieldConfigs[SECTION.BUYER_INFORMATION]"
    ></app-section-buyer-info>

    <app-section-additional-info
      [form]="form"
      [mode]="mode"
      [sourceType]="sourceType"
      [remoteConfig]="remoteConfig"
      [tagsCatalog]="tagsCatalog"
      [catalogsLoaded]="catalogsLoaded"
      [submitted]="formSubmitted"
      [fieldConfigs]="sectionFieldConfigs[SECTION.ADDITIONAL_INFO]"
    ></app-section-additional-info>

    <div class="pod-footer">
      <button
        type="button"
        class="rp-button rp-outlined rp-primary"
        [disabled]="!saveDraftEnabled || isSubmitting"
        (click)="saveDraft()"
      >
        {{ isSubmitting ? 'Saving…' : 'Save draft' }}
      </button>

      <button
        type="submit"
        class="rp-button rp-filled rp-primary"
        [disabled]="!primaryEnabled || isSubmitting"
      >
        {{ isSubmitting ? 'Saving…' : primaryLabel }}
      </button>
    </div>

  </form>

</div>
